<p-chip class="version-label badge" [label]="versionString" [pTooltip]="versionStringFull"></p-chip>
<p-tabView #mainTabView class="compact tab-view-no-pad height100p full-height flex-grow" id="mainTabView" [(activeIndex)]="tabIndex" (activeIndexChange)="activeTabChanged()">
    <p-tabPanel header="DocumentHandler">
        <p-tabView [class.tab-view-no-pad]="subTabIndex[0] == 0 || subTabIndex[0] == 5" [(activeIndex)]="subTabIndex[0]" (activeIndexChange)="activeTabChanged()">
            <p-tabPanel header="HQ">
                <app-document-handler-hq #viewDocumentHandlerHq class="block-100" [embeddedComponent]=true>
                </app-document-handler-hq>
            </p-tabPanel>
            <p-tabPanel header="Sim Log Suche">
                <app-sim-log #viewSimLog class="block-100" [embeddedComponent]=true>
                </app-sim-log>
            </p-tabPanel>
            <p-tabPanel header="Metrics">
                <app-metrics #viewMetrics class="block-100" [embeddedComponent]=true>
                </app-metrics>
            </p-tabPanel>
            <p-tabPanel header="Historie">
                <app-document-handler-runs #viewDocumentHandlerRuns class="block-100" [embeddedComponent]=true>
                </app-document-handler-runs>
            </p-tabPanel>
            <p-tabPanel header="Recherche">
                <app-document-handler-recherche #viewDocumentHandlerRecherche class="block-100" [embeddedComponent]=true>
                </app-document-handler-recherche>
            </p-tabPanel>
            <p-tabPanel header="Hilfe">
                <app-document-handler-help #viewDocumentHandlerHelp class="block-100" [embeddedComponent]=true>
                </app-document-handler-help>
            </p-tabPanel>
            <p-tabPanel header="Scriban Auswertungskonsole">
                <app-document-handler-eval-console #viewDocumentHandlerEvalConsole class="block-100" [embeddedComponent]=true>
                </app-document-handler-eval-console>
            </p-tabPanel>
            <p-tabPanel header="Profiling">
                <app-document-handler-profiling #viewDocumentHandlerProfiling class="block-100" [embeddedComponent]=true [useTimer]=true>
                </app-document-handler-profiling>
            </p-tabPanel>
            <p-tabPanel header="Stack Trace">
                <app-document-handler-stack-trace #viewDocumentHandlerStackTrace class="block-100" [embeddedComponent]=true [useTimer]=true>
                </app-document-handler-stack-trace>
            </p-tabPanel>
            <p-tabPanel header="Tools">
                <app-document-handler-tools #viewDocumentHandlerTools class="block-100" [embeddedComponent]=true>
                </app-document-handler-tools>
            </p-tabPanel>
            <p-tabPanel header="Updater">
                <app-document-handler-updater #viewDocumentHandlerUpdater class="block-100" [embeddedComponent]=true>
                </app-document-handler-updater>
            </p-tabPanel>
        </p-tabView>
    </p-tabPanel>
    <p-tabPanel class="group" header="enaio">
        <p-tabView [(activeIndex)]="subTabIndex[1]" (activeIndexChange)="activeTabChanged()">
            <p-tabPanel header="Objektdefinition">
                <app-enaio-object-def #viewEnaioObjectDef class="block-100" [embeddedComponent]=true>
                </app-enaio-object-def>
            </p-tabPanel>
            <p-tabPanel header="Workflows">
                <app-enaio-workflows #viewEnaioWorkflows class="block-100" [embeddedComponent]=true>
                </app-enaio-workflows>
            </p-tabPanel>
            <p-tabPanel header="Workflow-Details">
                <app-enaio-workflow #viewEnaioWorkflow class="block-100" [embeddedComponent]=true>
                </app-enaio-workflow>
            </p-tabPanel>
            <p-tabPanel header="Workflow-Modelle">
                <app-enaio-workflow-models #viewEnaioWorkflowModels class="block-100" [embeddedComponent]=true>
                </app-enaio-workflow-models>
            </p-tabPanel>
            <p-tabPanel header="Objekte">
                <app-enaio-objects #viewEnaioObjects class="block-100" [embeddedComponent]=true>
                </app-enaio-objects>
            </p-tabPanel>
            <p-tabPanel header="Benutzer">
                <app-enaio-users #viewEnaioUsers class="block-100" [embeddedComponent]=true>
                </app-enaio-users>
            </p-tabPanel>
            <p-tabPanel header="Suchen & Ersetzen">
                <app-enaio-search-and-replace #viewEnaioSearchAndReplace class="block-100" [embeddedComponent]=true>
                </app-enaio-search-and-replace>
            </p-tabPanel>
            <p-tabPanel header="Server API">
                <app-server-api-caller #viewEnaioServerApiCaller class="block-100" [embeddedComponent]=true>
                </app-server-api-caller>
            </p-tabPanel>
            <p-tabPanel header="Warnungen">
                <app-enaio-warnings #viewEnaioWarnings class="block-100" [embeddedComponent]=true>
                </app-enaio-warnings>
            </p-tabPanel>
            <p-tabPanel header="Server Info">
                <app-enaio-server-info #viewEnaioServerInfo class="block-100" [embeddedComponent]=true>
                </app-enaio-server-info>
            </p-tabPanel>
            <p-tabPanel header="ID Suche">
                <app-enaio-id-search #viewEnaioIdSearch class="block-100" [embeddedComponent]=true>
                </app-enaio-id-search>
            </p-tabPanel>
            <p-tabPanel header="Historie">
                <app-enaio-what-happened #viewEnaioWhatHappened class="block-100" [embeddedComponent]=true>
                </app-enaio-what-happened>
            </p-tabPanel>
            <p-tabPanel header="Lizenzen">
                <app-enaio-licenses #viewEnaioLicenses class="block-100" [embeddedComponent]=true>
                </app-enaio-licenses>
            </p-tabPanel>
            <p-tabPanel header="Watcher">
                <app-enaio-watcher #viewEnaioWatcher class="block-100" [embeddedComponent]=true>
                </app-enaio-watcher>
            </p-tabPanel>
            <p-tabPanel header="Web Client Debugger">
                <app-enaio-web-client-debugger #viewEnaioWebClientDebugger class="block-100" [embeddedComponent]=true>
                </app-enaio-web-client-debugger>
            </p-tabPanel>
        </p-tabView>
    </p-tabPanel>
    <p-tabPanel class="group" header="datev">
        <p-tabView [(activeIndex)]="subTabIndex[2]" (activeIndexChange)="activeTabChanged()">
            <p-tabPanel header="Rechnungs-Suche">
                <app-datev-invoice-search #viewDatevInvoiceSearch class="block-100" [embeddedComponent]=true>
                </app-datev-invoice-search>
            </p-tabPanel>
            <p-tabPanel header="Rechnungs-Zusammenfassung">
                <app-datev-invoice-summary #viewDatevInvoiceSummary class="block-100" [embeddedComponent]=true>
                </app-datev-invoice-summary>
            </p-tabPanel>
            <p-tabPanel header="Datenanzeige">
                <app-datev-data-fetcher #viewDatevDataFetcher class="block-100" [embeddedComponent]=true>
                </app-datev-data-fetcher>
            </p-tabPanel>
        </p-tabView>
    </p-tabPanel>
    <p-tabPanel class="group" header="Tools">
        <p-tabView [(activeIndex)]="subTabIndex[3]" (activeIndexChange)="activeTabChanged()">
            <p-tabPanel header="App Starter">
                <app-app-starter #viewAppStarter class="block-100" [embeddedComponent]=true>
                </app-app-starter>
            </p-tabPanel>
            <p-tabPanel header="System Info">
                <app-system-information #viewSystemInformation class="block-100" [embeddedComponent]=true>
                </app-system-information>
            </p-tabPanel>
            <p-tabPanel header="Connection Tester">
                <app-connection-tester #viewConnectionTester class="block-100" [embeddedComponent]=true>
                </app-connection-tester>
            </p-tabPanel>
            <p-tabPanel header="SM Code">
                <app-sm-code-generator #viewSmCodeGenerator class="block-100" [embeddedComponent]=true>
                </app-sm-code-generator>
            </p-tabPanel>
            <p-tabPanel header="Passwörter finden">
                <app-password-retriever #viewPasswordRetriever class="block-100" [embeddedComponent]=true>
                </app-password-retriever>
            </p-tabPanel>
            <p-tabPanel header="Datenbank Tools">
                <app-database-tools #viewDatabaseTools class="block-100" [embeddedComponent]=true>
                </app-database-tools>
            </p-tabPanel>
            <p-tabPanel header="MSGraph Tools">
                <app-ms-graph-tools #viewMsGraphTools class="block-100" [embeddedComponent]=true>
                </app-ms-graph-tools>
            </p-tabPanel>
            <p-tabPanel header="Dokumente">
                <app-text-extractor #viewDocuments class="block-100" [embeddedComponent]=true>
                </app-text-extractor>
            </p-tabPanel>
            <p-tabPanel header="Barcode Tester">
                <app-barcode-tester #viewBarcodeTester class="block-100" [embeddedComponent]=true>
                </app-barcode-tester>
            </p-tabPanel>
            <p-tabPanel header="Text Tools">
                <app-text-tools #viewTextTools class="block-100" [embeddedComponent]=true>
                </app-text-tools>
            </p-tabPanel>
            <p-tabPanel header="Diverses">
                <app-misc-tools #viewMiscTools class="block-100" [embeddedComponent]=true>
                </app-misc-tools>
            </p-tabPanel>
        </p-tabView>
    </p-tabPanel>
</p-tabView>
